import { render, staticRenderFns } from "./ImpactIcon.vue?vue&type=template&id=294840e1&"
import script from "./ImpactIcon.vue?vue&type=script&lang=js&"
export * from "./ImpactIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports